import { literalValues } from "@shared/validation/literal-values";

export const BUYER_ORDER_LIST_SCAN_LIMIT = 500;

export const ORDER_JOURNEY_FILTER = {
  NEEDS_ACTION: "needs_action",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
} as const;

export const ORDER_JOURNEY_FILTERS = literalValues(ORDER_JOURNEY_FILTER);

export type OrderJourneyFilter =
  (typeof ORDER_JOURNEY_FILTER)[keyof typeof ORDER_JOURNEY_FILTER];

export function parseOrderJourneyFilter(
  value: string | undefined,
): OrderJourneyFilter {
  const match = ORDER_JOURNEY_FILTERS.find((filter) => filter === value);
  return match ?? ORDER_JOURNEY_FILTER.NEEDS_ACTION;
}
